const maxXAxisLength = 9;

export function cutXAxisName(name: string, customLength?: number): string {
    let maxLength = customLength ?? maxXAxisLength;
    if (name.length <= maxLength) return name;
    return name.slice(0, maxLength).concat("...");
}
